import { Routes } from '@/assets/configs'
import { useIsQueryOwner } from '@/hooks'
import { useEMTState } from '@/store'
import { EmtButtonProps, EmtIcon } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'
import React from 'react'
import LinkButton from './LinkButton'
import useCurrentUser from '@/hooks/useCurrentUser'
import { hasPricesTrial } from '@/data'

type Props = EmtButtonProps

const BecomePremiumButton: React.FC<Props> = (props) => {
  const { fullWidth = true } = props
  const { t } = useTranslation('common')
  const [, , appendQueryType] = useIsQueryOwner(true)
  const { currentPrices = [] } = useEMTState().user

  const { isPremium } = useCurrentUser()

  const canUseTrial = hasPricesTrial(currentPrices)

  if (isPremium) {
    return null
  }

  return (
    <LinkButton
      fullWidth={fullWidth}
      color="secondary"
      startIcon={<EmtIcon className="emt-crown" />}
      href={appendQueryType(Routes.Premium.Base)}
      {...props}
    >
      {canUseTrial ? t('becomePremium.useFreeTrial') : t('becomePremium.noTrial')}
    </LinkButton>
  )
}

export default BecomePremiumButton
